import type { Variants } from 'framer-motion';

import { DECORATIVE_ANIMATIONS, DURATIONS, EASINGS, TRANSITIONS } from './constants';

export const heroImageVariants: Variants = {
  initial: { opacity: 0, scale: 0.8, y: 40 },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: DURATIONS.slowest,
      ease: EASINGS.soft,
      delay: 0.3,
    },
  },
};

export const pageTransitionVariants: Variants = {
  initial: {
    opacity: 0,
    y: 20,
    scale: 0.97,
  },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: DURATIONS.slow,
      ease: EASINGS.soft,
    },
  },
  exit: {
    opacity: 0,
    y: -15,
    scale: 0.97,
    transition: {
      duration: DURATIONS.normal,
      ease: EASINGS.out,
    },
  },
};

export const modalVariants: Variants = {
  initial: { opacity: 0, scale: 0.9, y: 20 },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: TRANSITIONS.spring,
  },
  exit: {
    opacity: 0,
    scale: 0.9,
    y: 20,
    transition: TRANSITIONS.fast,
  },
};

export const dropdownVariants: Variants = {
  initial: { opacity: 0, y: -10, scale: 0.95 },
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: TRANSITIONS.fast,
  },
  exit: {
    opacity: 0,
    y: -10,
    scale: 0.95,
    transition: TRANSITIONS.fast,
  },
};

export const pageContentVariants: Variants = {
  initial: {
    opacity: 0,
    y: 12,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: DURATIONS.slow,
      ease: EASINGS.gentle,
    },
  },
};

export const pageChildVariants: Variants = {
  initial: { opacity: 0, y: 16 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: DURATIONS.normal,
      ease: EASINGS.soft,
    },
  },
};

export const overlayVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export const galleryVariants: Variants = {
  initial: { opacity: 0, scale: 0.95 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: EASINGS.gentle,
    },
  },
  exit: {
    opacity: 0,
    scale: 1.05,
    transition: {
      duration: DURATIONS.normal,
    },
  },
};

export const blobAnimation = DECORATIVE_ANIMATIONS.float;
